/**
 * Hotel Chain Create/Edit forms.
 */

import React from 'react';
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  useTranslate,
  required,
  maxLength,
} from 'react-admin';
import { Grid } from '@mui/material';
import { MyToolbar } from '@/components/forms';

const ChainFormFields = () => {
  const translate = useTranslate();
  const f = (key: string) => translate(`resources.hotel-chains.fields.${key}`);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextInput
          source="name"
          label={f('name')}
          validate={[required(), maxLength(200)]}
          fullWidth
          helperText={false}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput source="website" label={f('website')} validate={maxLength(300)} fullWidth helperText={false} />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput source="country" label={f('country')} validate={maxLength(200)} fullWidth helperText={false} />
      </Grid>
      <Grid item xs={12}>
        <TextInput source="notes" label={f('notes')} multiline rows={4} fullWidth helperText={false} />
      </Grid>
    </Grid>
  );
};

export const ChainEdit = () => (
  <Edit mutationMode="pessimistic" redirect="list">
    <SimpleForm toolbar={<MyToolbar resource="hotel-chains" />}>
      <ChainFormFields />
    </SimpleForm>
  </Edit>
);

export const ChainCreate = () => (
  <Create redirect="list">
    <SimpleForm toolbar={<MyToolbar resource="hotel-chains" />}>
      <ChainFormFields />
    </SimpleForm>
  </Create>
);
